import service from '@/services'

export default {
  methods: {
    async clearExportedFile(filename) {
      try {
        const config = {
          url: '/clear-export',
          method: 'get',
          params: {
            filename,
          },
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (e) {
        if (e.response && e.response.data) {
          const blob = e.response.data
          const text = await blob.text()
          const errorJson = JSON.parse(text)

          return Promise.reject(errorJson)
        }
        return Promise.reject(e)
      }
    },
    async printAnalisis(params) {
      try {
        const config = {
          url: params.type_export == 'pdf' ? '/excel-data-analis' : '/excel-data-analis',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        if (params.type_export == 'pdf') {
          config.responseType = 'blob'
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (e) {
        return this.customRejectPromise(e)
      }
    },
  },
}
